import React, {useState} from "react";
import Switch from "react-bootstrap-switch";
import {CardBody, Col, Form, FormGroup, Input, Label, Row} from "reactstrap";
import {connect, useSelector} from "react-redux";
import {useForm} from "react-hook-form";


// components
import {ButtonClean, ButtonSearch} from "../../../components/buttons/buttonsActions";

// labels
import {LB_CODE, LB_ACTIVE} from "../../../components/i18n/i18n";
import {PH_CODE} from "../../../components/i18n/placeHolders";

// actions
import {setFilter} from "../../../redux/actions/generics/IndexedActions";

// utils
import {getStateByPath} from "../../../redux/selectors";
import SelectGeneric from "../../../components/select/selectGeneric";
import {activityProvider} from "../../../providers/activityProvider";
import {udnProvider} from "../../../providers/udnProvider";



const PromotionActivityFilters = (props) => {
    const componentState = useSelector(state => getStateByPath(state, props.path));
    const { path } = componentState;
    const { filter, app } = componentState?.data || {};
    const {fbDataBase} = app

    const [status, setStatus] = useState(filter?.status || null);
    const [activity, setActivity] = useState(filter?.activity?.id || null)
    const [udn, setUdn] = useState(filter?.udn?.id || null)


    const customFilters = {
        onlyRegistered:true,
        fbDataBase : { id :app?.fbDataBase?.id },
        item:{
            isExtraordinary: true
        }
    }



    const {register, handleSubmit, reset} = useForm({
        defaultValues: {
            title: filter?.title || '',
            code: filter?.code || ''
        }
    });

    const onSubmit = (data, _) => {
        const dataFilter = {
            fbDataBase,
            item : {  ...data,
                activity: activity ? { id: activity } : null,
                udn: udn ? { id: udn } : null
            }
        };

        if (status !== undefined && status !== null)
            dataFilter.item.isActive = status;

        props.setFilter(path, dataFilter);
    };

    const cleanFields = () => {
        setStatus(null)
        setActivity(null)
        setUdn(null)
        reset();
    }

    return <Form onSubmit={ handleSubmit(onSubmit) }>
        <CardBody>
            <Row>
                <Col md="4">
                    <FormGroup>
                        <SelectGeneric
                            title={'Unidad de Negocio'}
                            initialValue = { udn }
                            setExternalValue = { value => setUdn(value) }
                            provider = { udnProvider }
                        />
                    </FormGroup>
                </Col>

                <Col md="4">
                    <FormGroup>
                        <SelectGeneric
                            title={'Actividad'}
                            initialValue = { activity }
                            setExternalValue = { value => setActivity(value) }
                            provider = { activityProvider }
                            customFilter={customFilters}
                        />
                    </FormGroup>
                </Col>

                <Col md="2">
                    <FormGroup>
                        <Label>{'¿Promoción Activa?'}</Label>
                        <br/>
                        <Switch
                            animate={true}
                            offText={"No"}
                            onText={"Si"}
                            value={status}
                            onChange={ () => setStatus(!status) }
                        />
                    </FormGroup>
                </Col>
                <Col sm={12} className={'d-flex justify-content-center'}>
                    <div className="float-right ">
                        <ButtonSearch/>
                        <ButtonClean onClick={() => cleanFields()}/>
                    </div>
                </Col>
            </Row>
        </CardBody>
    </Form>
}

const mapStateToProps = state => ({})
const mapActionsToProps = ({setFilter})

export default connect(mapStateToProps, mapActionsToProps)(PromotionActivityFilters)